import { GlobalStyles as MUIGlobalStyles } from "@mui/material";
import { colors } from "styles/colors";

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
        },
        ".MuiCard-root": {
          backgroundImage: "none",
        },
        ".MuiCardContent-root:last-child": {
          paddingBottom: "36px",
        },
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
        "input[type=number]": {
          MozAppearance: "textfield",
        },
        ".MuiPopover-paper": {
          backgroundImage: "none",
          backgroundColor: colors.back1D,
          marginTop: "10px",
          borderRadius: "10px",
          "& ul": {
            paddingBlock: 0,
            "& > *": {
              padding: "10px 15px",
            },
          },
        },
        ".MuiMenuItem-root.Mui-selected:hover, .MuiMenuItem-root.Mui-selected":
          {
            backgroundColor: "#333a59",
          },
        ".MuiPickersPopper-paper": {
          marginTop: "10px",
          borderRadius: "10px",
          backgroundImage: "none",
          backgroundColor: colors.back36,
        },
        "#chart .apexcharts-tooltip": {
          color: colors.whiteFF,
        },
        "#chart .apexcharts-tooltip.apexcharts-theme-dark,": {
          backgroundColor: colors.back36,
        },
        "#chart .apexcharts-tooltip-title": {
          backgroundColor: colors.back36,
          borderBottom: `1px solid ${colors.greyD9}`,
        },
      }}
    />
  );

  return inputGlobalStyles;
}
